export const NOTIFICATION_FILTER_OPTIONS = [
  {
    title: 'Filter by',
    items: [
      { label: 'Long wait to start', value: 'iddle_start' },
      { label: 'Long wait to undock', value: 'iddle_end' },
      { label: 'Unassigned code detected', value: 'missing_tags' },
      { label: 'Slow progress', value: 'process_slow' },
      { label: 'Process stopped', value: 'process_stopped' },
    ],
  },
];